function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(32 32) scale(1.12) translate(-32 -32)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 14h12l5 5h17c2.2 0 4 1.8 4 4v22c0 2.2-1.8 4-4 4H15c-2.2 0-4-1.8-4-4V18c0-2.2 1.8-4 4-4z",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 4.5,
  strokeLinejoin: "round",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 29,
  r: 6,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 45c2.8-7 7.8-10.5 11-10.5S40.2 38 43 45",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 4,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 49,
  width: 42,
  height: 9,
  rx: 2.5,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M28 53.5h8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 3.5,
  strokeLinecap: "round"
}));

var SvgIManagement = function SvgIManagement(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIManagement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i_management.0e9244d2.svg";
export { ForwardRef as ReactComponent };